import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MobileAppHelperBaseService } from '@fi-shared/fi-shared-services/mobile-app-helper-base.service';
import { base64toUint8Array } from '@fi-shared/utils/base64toUint8Array';

let nextId = 0;

@Component({
    selector: 'fi-insert-media-upload-helper',
    template: `
        <input
            type="file"
            tabindex="-1"
            [hidden]="true"
            #inputFile
            [attr.accept]="accept"
            [attr.multiple]="multiple"
            (change)="inputFileChanged($event)"
        />
        <input
            type="file"
            tabindex="-1"
            #inputCamera
            [hidden]="true"
            accept="image/*"
            capture
            (change)="inputFileChanged($event)"
        />
    `,
    styleUrls: ['./fi-insert-media-upload-helper.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-insert-media-upload-helper' },
    standalone: false,
})
export class FiInsertMediaUploadHelperComponent implements OnInit {
    @Input() accept: string;
    @Input() multiple: boolean = true;
    @Output() onFilesSelect = new EventEmitter<ArrayLike<File>>();

    @ViewChild('inputFile', { static: true }) inputFileElement: ElementRef<HTMLInputElement>;
    @ViewChild('inputCamera', { static: true }) inputCameraElement: ElementRef<HTMLInputElement>;

    mobileAppTakePictureCallbackName: string;

    constructor(private mobileAppHelperService: MobileAppHelperBaseService) {}

    ngOnInit() {}

    onBrowseDeviceInvoked() {
        this.inputFileElement.nativeElement.value = '';
        this.inputFileElement.nativeElement.click();
    }

    onUseCameraInvoked() {
        if (this.mobileAppHelperService.mobileAppMode) {
            this.mobileAppTakePictureCallbackName = `FiMobileAppOpenCameraFor:${++nextId}`;
            this.mobileAppHelperService.takePicture(this.mobileAppTakePictureCallbackName).then((data) => {
                this.processCameraResponse(data.fileData);
            });
        } else {
            this.inputCameraElement.nativeElement.value = '';
            this.inputCameraElement.nativeElement.click();
        }
    }

    private processCameraResponse(fileData: string) {
        const file: any = new Blob([base64toUint8Array(fileData)], { type: 'image/jpeg' });
        file.name = 'picture.jpeg';
        this.onFilesSelect.emit([file]);
    }

    inputFileChanged($event: any) {
        if ($event.target && $event.target.files.length > 0) {
            this.onFilesSelect.emit($event.target.files);
        }
    }
}
